import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    if (!cache) api.get("/config").then((r) => { cache = r.data; setCfg(r.data); }).catch(() => {});
  }, []);
  return cfg;
}
